<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-09 16:45:58
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2021-12-22 17:17:08
-->
<template>
  <div class="content">
    <div class="top-info">
      <div class="title-wrap">
        <h2 class="title">轨迹回放信息</h2>
        <el-button @click="handleQuitTrajectoryPlay" type="primary" plain round
          ><i class="el-icon-switch-button"></i>退出</el-button
        >
      </div>
    </div>
    <el-table :data="info" border style="width: 100%">
      <el-table-column
        prop="driverName"
        label="机手"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="machineryName"
        label="作业机具"
        min-width="15%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="sendDate"
        label="作业时间"
        min-width="15%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="blockArea"
        label="作业面积"
        min-width="15%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="machineryCode"
        label="出厂编号"
        min-width="15%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="imei"
        label="北斗终端编号"
        min-width="15%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
    </el-table>
    <div class="map-wrap">
      <div class="map" id="map" ref="map"></div>
      <div class="map-bottom-info" v-show="statusStatic">
        <ul class="list">
          <li
            class="item"
            :class="calendarFlag == true ? 'img-onlyRead' : ''"
            @click.stop="handleSpeedChange('slowdown')"
          >
            <i class="iconfont icon-jiansu"></i>
            <span>减速</span>
          </li>
          <li
            class="item"
            @click.stop="handlePlay(operationForPauseAndContinue)"
          >
            <img :src="continueOrStopUrl" id="starImg" />
            <span id="pauseBtns">播放</span>
          </li>
          <li
            class="item"
            :class="calendarFlag == true ? 'img-onlyRead' : ''"
            @click.stop="handleSpeedChange('accelerate')"
          >
            <i class="iconfont icon-jiasu"></i>
            <span>加速</span>
          </li>
        </ul>
        <ul class="speed-list" v-if="popVisible">
          <li
            class="item"
            v-for="(item, index) in speedList"
            :key="index"
            :class="{ active: index == speedIsActive }"
            @click.stop="handlePlay('accelerate', index)"
          >
            {{ item.speedTimes }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import TalksMap from "@/utils/initMapTalks.js";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      TalksMapDialog: new TalksMap(),
      popVisible: false, // 是否展示速度选择框
      speedIsActive: 1, // 选中的速度索引
      speedList: [
        {
          speedTimes: "0.5X",
          speed: 800,
        },
        {
          speedTimes: "1X",
          speed: 400,
        },
        {
          speedTimes: "2X",
          speed: 200,
        },
        {
          speedTimes: "3X",
          speed: 133,
        },
      ],
      info: [],
      trajectoryList: [],
      stopedIndex: 0, //?????
      calendarFlag: true, //????
      operationForPauseAndContinue: "start",
      kaishi: require("@/assets/start.png"),
      continueOrStopUrl: require("@/assets/start.png"),
      tingzhi: require("@/assets/stop.png"),

      iconStop: "icon-bofang",
      iconStart: "icon-zanting",
      palyBtnStatusClass: "icon-bofang",

      statusStatic: false,
    };
  },
  computed: {
    ...mapState("map", {
      trajectoryPlay: (state) => state.trajectoryPlay,
      handleName: (state) => state.kName,
    }),
  },
  watch: {
    trajectoryPlay: {
      handler: function (n) {
        if (n && n.show) {
          this.getTrajectoryPlayback(n.workId);
        }
      },
      deep: true,
      immediate: true,
    },
    handleName(newVal, oldVal) {
      if (newVal == "end") {
        this.operationForPauseAndContinue = "start";
        document.getElementById("pauseBtnsText").innerHTML = "开始";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
      }
    },
  },
  mounted() {
    let this_ = this;
    this.getMapInit();
    this.TalksMapDialog.sendThis(this);
    document.addEventListener("click", function (e) {
      if (this_.popVisible === true) {
        this_.popVisible = false;
      }
    });
  },
  beforeDestroy() {
    //清除小车跑定时器
    if (this.TalksMapDialog._timer || this.TalksMapDialog.i > 0) {
      clearInterval(this.TalksMapDialog._timer);
      this.TalksMapDialog._timer = "";
    }
  },
  methods: {
    ...mapActions("map", ["changeTrajectoryPlay"]),
    /**
     * @descripttion: 地图初始化
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:40:39
     */
    getMapInit() {
      this.TalksMapDialog.init("map", 16);
    },
    /**
     * @descripttion: 改变回放速度
     * @Author: juanjuanhui
     * @Date: 2021-12-09 17:25:02
     * @param {*} typeName 加速或减速
     */
    handleSpeedChange(typeName) {
      if (this.popVisible) {
        if (typeName == "slowdown") {
          this.speedIsActive =
            this.speedIsActive == 0 ? 0 : this.speedIsActive - 1;
        } else {
          let len = this.speedList.length - 1;
          this.speedIsActive =
            this.speedIsActive == len ? len : this.speedIsActive + 1;
        }
        this.speedNum = this.speedList[this.speedIsActive].speed;
        if (this.trajectoryList.length > 0) {
          this.TalksMapDialog.playBack(
            this.trajectoryList,
            typeName,
            this.stopedIndex,
            this.stopedIndex > 0,
            undefined,
            this.speedNum
          );
        }
      } else {
        this.popVisible = true;
      }
    },
    /**
     * @descripttion: 轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-09 17:38:42
     * @param {*} typeName
     * @param {*} index
     */
    handlePlay(typeName, index) {
      if (index || index === 0) {
        this.speedNum = this.speedList[index].speed;
      }
      if (document.getElementById("pauseBtns").innerHTML === "开始") {
        typeName = "start";
      }
      if (typeName === "start") {
        console.log(this);
        //开始
        let name_ = this.$store.state.map.kName;
        this.$store.state.map.kName = name_ ? "" : "start";
        this.stopedIndex = 0;
        this.calendarFlag = false;
        this.operationForPauseAndContinue = "pause";
        document.getElementById("starImg").src = require("@/assets/stop.png");
        this.continueOrStopUrl = this.tingzhi;
        this.speedNum = 400;
        this.speedIsActive = 1;
      } else if (typeName === "pause") {
        //停止
        this.stopedIndex = this.TalksMapDialog.i;
        this.operationForPauseAndContinue = "continue";
        document.getElementById("pauseBtns").innerHTML = "继续";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "continue") {
        //继续
        this.operationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        this.continueOrStopUrl = this.tingzhi;
        this.calendarFlag = false;
      } else if (typeName === "stop") {
        this.TalksMapDialog.lastLinePoints = [];
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "accelerate") {
        //加速减速
        this.speedIsActive = index;
        this.speedNum = this.speedList[index].speed;
      }
      if (this.trajectoryList.length > 0) {
        this.TalksMapDialog.playBack(
          this.trajectoryList,
          typeName,
          this.stopedIndex,
          this.stopedIndex > 0,
          undefined,
          this.speedNum
        );
      }
    },
    getTrajectoryPlayback(workId) {
      this.$http.work.getTrajectoryPlayback({ workId }).then((res) => {
        let { trackLinestring, ...data } = res.data;
        let trajectoryList = JSON.parse(trackLinestring);
        if (trackLinestring.length == 0) {
          return;
        }
        this.statusStatic = true;
        this.info = [data];
        this.trajectoryList = trajectoryList;
        let Coordinate = {
          x: trajectoryList[0][0],
          y: trajectoryList[0][1],
        };
        this.TalksMapDialog.map.setCenter(Coordinate);
        this.TalksMapDialog.drawLine(trajectoryList);
      });
    },
    /**
     * @descripttion: 退出轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-10 10:08:38
     * @param {*}
     * @return {*}
     */
    handleQuitTrajectoryPlay() {
      this.handlePlay("stop");
      this.changeTrajectoryPlay({ show: false, workId: "" });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .top-info {
    .title-wrap {
      position: relative;
      display: flex;
      align-items: center;
      min-height: 34px;
      padding: 15px 0;
      .title {
        width: 70%;
        margin: 0 auto;
        font-size: 24px;
        text-align: center;
        color: #018388;
      }
      .el-button {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        height: 34px;
        padding: 0 15px;
        background-color: #ebf5f6;
        &:hover {
          background-color: #018388;
        }
        span {
          display: flex;
        }
        i {
          margin-right: 3px;
        }
      }
    }
  }
  .map-wrap {
    position: relative;
    height: 60vh;
    margin-top: 10px;
    overflow: hidden;
    background-color: #f1f3f8;
    .map {
      width: 100%;
      height: 100%;
    }
    .map-bottom-info {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 54px;
      background: rgba($color: #000000, $alpha: 0.5);
      .list {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 0 3%;
          padding: 0 2%;
          color: #fff;
          cursor: pointer;
          i {
            font-size: 20px;
          }
          img {
            width: 28px;
          }
        }
      }
      .speed-list {
        position: absolute;
        top: -51px;
        left: 50%;
        transform: translateX(-50%);
        width: 20%;
        padding: 10px 20px;
        background-color: rgba($color: #000000, $alpha: 0.5);
        border-radius: 10px;
        display: flex;
        .item {
          flex: 1;
          display: flex;
          justify-content: center;
          color: #fff;
          cursor: pointer;
          &.active {
            color: #018388;
          }
        }
      }
    }
  }
}
.img-onlyRead {
  pointer-events: none;
}
</style>
